import { gql } from '@apollo/client';

export const CREATE_PIXEL = gql`
        mutation createPixel($clientName: String!, $clientDomain: String!, $pixelId: String!) {
            createPixel(clientName: $clientName, clientDomain: $clientDomain, pixelId: $pixelId) {
                clientName
                clientDomain
                pixelId
                createdAt
                updatedAt
              }
        }
    `

export const SEARCH_PIXELS = gql`
        query searchPixels($clientName: String!, $clientDomain: String!) {
            searchPixels(clientName: $clientName, clientDomain: $clientDomain) {
                clientName
                clientDomain
                pixelId
                createdAt
                updatedAt
            }
        }
    `
